import React, { useState , useEffect} from 'react';
import { BrowserRouter,Routes, Route, Navigate,useHistory,useLocation,useNavigate} from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import Index from './components/App';
import Dashboard from './pages/Dashboard';
import QRDocument from './pages/QRDocument';

import Login from './pages/Login';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './constants';
function App() {
	
  return (
	
    <BrowserRouter>
		<Routes>
			<Route path={URLPREFIX+"/login"}  element={<Login />}  />
			<Route path={URLPREFIX+"/index"}  element={<Index />}  />
			<Route path={URLPREFIX+"/view/dashboard"}  element={<Dashboard formId='dashboard'/>}  />
			<Route path={URLPREFIX+"/create/assetType"}  element={<Dashboard formId='create-asset-type' />}  />
			<Route path={URLPREFIX+"/create/user"}  element={<Dashboard formId='create-user' />}  />
			<Route path={URLPREFIX+"/create/implAgency"}  element={<Dashboard formId='create-impl-agency' />}  />
			<Route path={URLPREFIX+"/create/userAgency"}  element={<Dashboard formId='create-user-agency' />}  />
			<Route path={URLPREFIX+"/create/fundingAgency"}  element={<Dashboard formId='create-funding-agency' />}  />
			<Route path={URLPREFIX+"/add/engineer"}  element={<Dashboard formId='add-engineer' />}  />

			<Route path={URLPREFIX+"/create/document"}  element={<Dashboard formId='create-document' />}  />
			<Route path={URLPREFIX+"/list/document"}  element={<Dashboard formId='list-document' />}  />
			<Route path={URLPREFIX+"/list/user"}  element={<Dashboard formId='list-user' />}  />
			<Route path={URLPREFIX+"/update/credential"}  element={<Dashboard formId='update-credential' />}  />
			<Route path={URLPREFIX+"/view/document-detail"}  element={<Dashboard formId='document-details' />}  />
			<Route path={URLPREFIX+"/public/document-detail"}  element={<QRDocument/>}  />

			<Route path={URLPREFIX+"/report/assets-projects"}  element={<Dashboard formId='report-assets-projects' />}  />
			<Route path={URLPREFIX+"/report/implementing-agency"}  element={<Dashboard formId='report-implementing-agency' />}  />

			<Route path={URLPREFIX+"/view/openstreet-map"}  element={<Dashboard formId='openstreet-map'/>}  />

			<Route path={URLPREFIX+"/working/document"}   element={<Dashboard formId='working-list-document' />}  />
			<Route path={URLPREFIX+"/list/document"}   element={<Dashboard formId='list-document' />}  />
			<Route path={URLPREFIX+"/list/document/implementing-agency-vba"}  element={<Dashboard formId='list-document-implementing-agency-vbadmin' />}  />
			<Route path={URLPREFIX+"/list/document/assettype-vba"}  element={<Dashboard formId='list-document-assettype-vbadmin' />}  />
			<Route path={URLPREFIX+"/list/document/contractors-projects-vba"}  element={<Dashboard formId='list-document-contractor-vbadmin' />}  />
			<Route path={URLPREFIX+"/list/document/delayed-projects-between-days"}  element={<Dashboard formId='list-document-delayed-between-days' />}  />
			
			<Route path={URLPREFIX+"/list/document/nearto"}  element={<Dashboard formId='nearest-assets-projects' />}  />
			<Route path={URLPREFIX+"/list/document/contractor-performance"}  element={<Dashboard formId='contractor-performance' />}  />
			
			<Route path={URLPREFIX+"/list/public/remarks"}  element={<Dashboard formId='public-remarks' />}  />

			<Route path={URLPREFIX+"/payment/add"}  element={<Dashboard formId='payment-add' />}  />
			<Route path={URLPREFIX+"payment/info"}  element={<Dashboard formId='payment-info' />}  />
			
		</Routes>
	</BrowserRouter>
  );
}

export default App;
